import { apiGet, apiPost } from '../lib/api-client';

export interface DeviceCategory {
  id: number;
  name: string;
  slug: string;
  icon: string;
  description?: string;
  sortOrder: number;
  isActive: boolean;
}

export interface DeviceBrand {
  id: number;
  categoryId: number;
  name: string;
  slug: string;
  logo?: string;
  sortOrder: number;
  isActive: boolean;
}

export interface DeviceModel {
  id: number;
  brandId: number;
  name: string;
  slug: string;
  image?: string;
  sortOrder: number;
  isActive: boolean;
}

export interface FaultType {
  id: number;
  name: string;
  slug: string;
  icon: string;
  description?: string;
  categoryId?: number;
  sortOrder: number;
  isActive: boolean;
}

export const deviceService = {
  async getCategories(): Promise<DeviceCategory[]> {
    return apiGet<DeviceCategory[]>('/devices/categories');
  },

  async getBrands(categoryId: number): Promise<DeviceBrand[]> {
    return apiGet<DeviceBrand[]>(`/devices/brands/${categoryId}`);
  },

  async getModels(brandId: number): Promise<DeviceModel[]> {
    return apiGet<DeviceModel[]>(`/devices/models/${brandId}`);
  },

  async createModel(brandId: number, name: string): Promise<DeviceModel> {
    return apiPost<DeviceModel>('/devices/models', { brandId, name });
  },

  async getFaults(categoryId?: number): Promise<FaultType[]> {
    const url = categoryId ? `/devices/faults?categoryId=${categoryId}` : '/devices/faults';
    return apiGet<FaultType[]>(url);
  },
};